import { OverlayPanel } from "primereact/overlaypanel";
import CheckMenu from "../pengecekan-form/CheckMenu";

// The popover of a checklist row: its note and its photo.
const EditorPopover = ({
  overlayRef,
  popoverPengecekanData,
  handleOnClickFoto,
  handleOnClickEditNote,
}) => {
  return (
    <OverlayPanel
      className=""
      ref={overlayRef}
      pt={{ content: { className: "col-start-center py-1 px-0" } }}
    >
      <CheckMenu
        row={popoverPengecekanData}
        onClickFoto={handleOnClickFoto}
        onClickEditNote={handleOnClickEditNote}
      />
    </OverlayPanel>
  );
};

export default EditorPopover;
